import React, {Component} from 'react';
// import { Button } from 'reactstrap';
import propTypes from 'prop-types';
import Moment from "moment"
import {Link} from "react-router-dom"

class ItemClick extends Component {
    render() {
        const {dataClick} = this.props;
        const now = Moment();
        const createdTime = Moment(dataClick.created);
        const backwardTime = Moment.duration(createdTime.diff(now));
        const referralLink = dataClick.meta.referer;
        return (
            <tr className="ItemClick">
                <td><Link to={'/a/users/'.concat(dataClick.owner._id)}> {dataClick.owner.name}</Link></td>
                <td>{dataClick.owner.email}</td>
                <td>{referralLink}</td>
                <td>
                    <div className='tooltip-container'>{backwardTime.humanize(true)}
                        <span
                            className="tooltip-text">{createdTime.format('DD-MM-YYYY')}</span>
                    </div>
                </td>

                <td>{dataClick.meta.IP}</td>
            </tr>
        );
    }
}

ItemClick.propTypes = {
    dataClick: propTypes.object.isRequired
}

export default ItemClick;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/affiliate/list-clicks/ItemClick.js